import { render, staticRenderFns } from "./NormalSearchNav379.vue?vue&type=template&id=673471d8&scoped=true&"
import script from "./NormalSearchNav379.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav379.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673471d8",
  null
  
)

export default component.exports